export interface CallConfig {
  welcomingAnnouncement: string;
  lang: string;
}
